import {css} from "lit";
import {commonStyles} from "../common/styles/Common.js";
import {customScrollStyles} from "../common/styles/CustomScrollBar.js";

export const sidebarStyles = [commonStyles, customScrollStyles, css`
	/** Limit size and set scroll bars for integrated sidebar **/
	aside {
		max-height: 90vh;
		overflow-x: hidden;
		overflow-y: auto;
	}

	aside.is-floating {
		--pn-sidebar-z-index: 2147483627;
		background: #fff;
		-webkit-box-shadow: 0 0 10px rgba(0,0,0,.4);
		-webkit-box-sizing: border-box;
		box-sizing: border-box;
		margin-right: var(--pn-sidebar-margin-right);
		/* margin-top:var(--pn-sidebar-margin-top); */
		overflow: hidden;
		padding: 0;
		position: fixed;
		right: 0;
		top: 0;
		user-select: none;
		z-index: var(--pn-sidebar-z-index);

		width: 40vw;
		min-width: 400px;
		max-width: 500px;
		height: 100%;
		max-height: 100%;
	}

	aside.is-int-sidebar-hidden {
		/* TODO: is there are better way of not causing scroll bars? */
		overflow-y: visible;
	}

	.hidden {
		display: none;
	}
	
	.state-loading {
		height: calc(100vh - 150px);
		display: flex;
		flex-direction: column;
		justify-content: center;
	}

	.state-outline pn-sidebar-outline {
		display: block;
	}
	.state-outline pn-citation-panel, .show-state .aa-citation-container-legacy {
		display: none;
	}

	.state-citation pn-sidebar-outline {
		display: none;
	}

	.state-citation pn-citation-panel {
		display: flex;
	}

	.state-citation .aa-citation-container-legacy {
		display: block;
	}

	.state-restore-session :not(pn-restore-session) {
		display: none;
	}

	/** Skip links **/
	#skip-links-container button {
		/* Style it like a link (web app skip links for reference) */
		position: absolute;
		top: -5em;
		font-size: var(--pn-font-size-base);
	}

	#skip-links-container button:focus {
		top: 1em;
		left: 1em;
		z-index: 1; /* Or it might get hidden under the P icon */
		background-color: white;
		text-decoration: underline;
		outline: thin dotted;
		color: var(--pn-color-link-hover);
	}
`];
